import { useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { NEW_PROJECT_ID_PARAM, V_EDITOR_INSTRUCTIONS } from 'consts'
import { useAddAiItemToTimeline } from 'hooks/useAddAiItemToTimeline'
import { userSelectors } from 'store/features/user/selectors'
import { convertAiVideoToBaseMediaItem } from 'containers/SubSidebar/AIVideoContent/HistoryTab/utils'
import {
  clearVEditorInstructions,
  readVEditorInstructionsPayload
} from 'utils/vEditorInstructions'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'

/**
 * Applies an AI-video item left in localStorage under `v-editor-instructions` when opening
 * `/new` (a same-origin host's “Open in advanced editor”). The payload's `data` arrives in the
 * editor's own AI-video shape, so it goes through the same path as the history tab.
 */
export const useVEditorInstructions = () => {
  const { projectId } = useParams()
  const userIsLoading = useSelector(userSelectors.isLoading)
  const loggedInUserId = useSelector(userSelectors.userId)
  const addItemToTimeline = useAddAiItemToTimeline()
  const didApplyRef = useRef(false)
  const videoModels = useSelector(aiVideoSelectors.hasVideoModels)

  useEffect(() => {
    if (!videoModels) return
    if (didApplyRef.current) return
    if (projectId !== NEW_PROJECT_ID_PARAM) return
    if (!localStorage.getItem(V_EDITOR_INSTRUCTIONS)) return

    if (userIsLoading) return

    const payload = readVEditorInstructionsPayload()
    if (!payload) return

    if (
      payload.userId !== null &&
      !!loggedInUserId &&
      payload.userId !== loggedInUserId
    ) {
      clearVEditorInstructions()
      return
    }

    didApplyRef.current = true
    addItemToTimeline(convertAiVideoToBaseMediaItem(payload.data))
    clearVEditorInstructions()
  }, [projectId, userIsLoading, loggedInUserId, addItemToTimeline, videoModels])
}
